import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import {InputSelect} from '@emersya/mpa-components';


export interface IPlannerLayoutEditorComponentConfiguration extends InputSelect.Configuration {
	readonly shapes: Record<string, PlannerLayoutOptionTileNS.Configuration>;
};

export class PlannerLayoutEditorComponent extends InputSelect.Component<
	PlannerLayoutEditorComponent,
	IPlannerLayoutEditorComponentConfiguration
> {
	static override getInputEventSubType() {
		const parentClass = <typeof CM.Component>STD.object.getParentClassFromClass(this);
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Select', {});
		}
		return parentClass.type;
	};

	private async addLayout(id: string, cfg: PlannerLayoutOptionTileNS.Configuration) {
		if (!app.basket) {
			this.component_throwLibraryError('', {});
		}
		const innerConf = cfg['@innerConfigurations'];
		if (!innerConf) {
			this.component_throwUserError('', {});
		}
		const title = innerConf.title;
		if (!title) {
			this.component_throwUserError('', {});
		}
		const translations = title['@translations'];
		if (!translations) {
			this.component_throwUserError('', {});
		}
		const text = translations.text;
		if (!text) {
			this.component_throwUserError('', {});
		}
		const currentTrad = text[app.currentLanguage];
		if (!currentTrad) {
			this.component_throwUserError('', {});
		}
		for (const product of app.basket.basket.products) {
			const layoutPart = product.getPart(['layout']);
			const option = layoutPart.createOption({
				id,
				title: currentTrad,
				reference: {value: id},
				pricingInfo: null,
				technicalFees: null,
				metaData: {
					translations: text
				},
				components: [],
				thumbnail : {
					type : 'image',
					value : STD.net.URL_normalize(cfg.iconURL)
				}
			});
			void option;
		}
		await this.component_instantiateOuterChild<PlannerLayoutOptionTileNS.Configuration>(
			{
				type: 'viewer-planner-layout-optionTile',
				id: id,
				tree: this.component_tree,
				slot: null,
				isSlot: false,
				configuration: cfg
			}
		);
	};

	override async component_initialize() {
		if (!app.basket) {
			this.component_throwLibraryError('', {});
		}
		for (const product of app.basket.basket.products) {
			const part = product.createPart({
				id: 'layout',
				title: 'Layout',
				reference: null,
				metaData: null,
				parts: [],
				options: []
			});
			await part.initialize();
		}
		for (const [id, cfg] of Object.entries(this.component_configuration.shapes)) {
			await this.addLayout(id, cfg);
		}
		await super.component_initialize();
	};

	override async component_start(ev: STD.events.Event<any, any>) {
		await super.component_start(ev);
	};

	protected override async onValueUpdated(ev: STD.events.Event<any, CM.Component<any, any>>) {
		await super.onValueUpdated(ev);
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('', {});
		}
		const layoutPart = app.basket.basket.currentProduct.getPart(['layout']);
		if (!this.value) {
			if (layoutPart.currentOption) {
				await layoutPart.unuseOption();
			}
		} else {
			await layoutPart.useOption(this.value.id);
		}
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IPlannerLayoutEditorComponentConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement>STD.DOM.factory({
			tag: 'div'
		});
	};
};
export namespace NS {
	export const Component = PlannerLayoutEditorComponent;
	export type Component = PlannerLayoutEditorComponent;
	export type Configuration = IPlannerLayoutEditorComponentConfiguration;
}
import manifestXMLSource from './PlannerLayoutEditor.xml';
import './PlannerLayoutEditor.scss';
import {NS as PlannerLayoutOptionTileNS} from '../OptionTile/PlannerLayoutOptionTile';

CM.Manager.declare({
	id: 'viewer-planner-layout-editor',
	type: PlannerLayoutEditorComponent,
	manifest: manifestXMLSource
});
